module.exports = __webpack_public_path__ + "static/media/aoe-circle.0a6787b3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsters/aoe-circle.svg
// module id = 58
// module chunks = 0